import SocketService from "./socketService";

export default SocketService;
